
























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class bookSales extends Vue {
  @Prop() public checkedDeliveryItems:Array<Common.SalesDeliveryItem>; 
  @Prop() public parentMainList:Components.ListView;
  @Prop() public salesDeliveryItems:Components.GrdVoucherItem;
  @Prop() public parentSalesDelivery:Common.SalesDelivery;
  @Prop() public parent:any;
  @Prop() public isItemFlag:boolean;
  // 出荷一覧からの一括請求用プロパティ
  @Prop() public execDelivery:boolean;
  @Prop() public deliveries:Array<Common.Delivery>;
  @Prop({ default: false}) public isSeparate:boolean;

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 請求処理用のプロパティ
  public bsInvoiceType: Common.InvoiceTypes = Common.InvoiceTypes.SeparateInvoice;
  public bsPaymentDateType: Common.PaymentDateTypes = Common.PaymentDateTypes.None;
  public bsSeparateInvoiceFlag: boolean = false;
  public bsBookDateChangeFlag: boolean = false;
  public bsBookDate: Date = new Date;
  public bsDueDate: Date = new Date;
  public bsCurrencyCode: string = "";
  public bsExchangeRate: number = 1;
  public bsEnabledSeparateInvoiceFlag: boolean = false;
  public bsEnabledBookDate: boolean = false;
  public bsCarryOverInvoiceFlag: boolean = false;
  public bsCounterpart: Common.Counterpart = null;
  public bsBankAccount: Common.BankAccount = null;
  public bsWorkflowIdAlone:number = 0;
  public bsWorkflowIdCarryOver:number = 0;
  public bsHasAlone:boolean = true;
  public bsHasCarryOver:boolean = true;
  public hasLicenseCurrency: boolean = false;
  public hiddenAtcBankAccount = false;  // 一括請求で請求口座がブランクの請求先がある場合true

  
  // 請求処理ダイアログの表示
  public mounted(){
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    // 一括出荷処理
    if(this.execDelivery == true){
      // プロパティの初期化
      this.bsPaymentDateType = Common.PaymentDateTypes.None;
      this.bsExchangeRate = 1;
      this.bsCurrencyCode = this.$api.tenantSettings.currencyCode; 
      this.bsWorkflowIdAlone = this.$api.perms.getDefaultWorkflowId('workflow_aloneInvoice');
      this.bsCounterpart = this.deliveries[0].counterpart.payer?? this.deliveries[0].counterpart;
      this.bsBookDate = (this.deliveries[0].counterpart.payer?? this.deliveries[0].counterpart).getClosingDate(this.deliveries[0].deliveryDate,this.$api.tenantSettings);
      // this.bsWorkflowIdCarryOver = this.$api.perms.getDefaultWorkflowId('workflow_carryOverInvoice' );
      this.onChangeWorkflow();
      this.bsHasCarryOver = false;
      this.hiddenAtcBankAccount = this.deliveries.filter(obj => !((obj.counterpart.payer??obj.counterpart).customerBankAccountCode)).length == 0;
      if(this.isSeparate == true){
        this.bsBookDate = new Date().getCalendarDate();
        this.bsDueDate = this.bsCounterpart.getPaymentDate(this.bsBookDate, this.$api.tenantSettings);
        this.bsSeparateInvoiceFlag = true;
      }
      // ダイアログの表示
      (this.$refs.bookSalesDialog as Components.ListDialog).showDialog();
    }
    else{
    // 出荷から実行した場合に必要な情報の設定
    if(this.parentSalesDelivery)
    {
      this.checkedDeliveryItems.forEach(item => {
        item.delivery = this.parentSalesDelivery;
        item.segment = this.parentSalesDelivery.segment;
      });
    }

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    var parentDelivery = this.checkedDeliveryItems[0].delivery;
    // 取引先マスタに請求先が未実装のため、請求先チェックは保留
    if(this.checkedDeliveryItems.filter(item => ( (parentDelivery ? parentDelivery.counterpart.id : 0) != (item.delivery ? item.delivery.counterpart.id : 0))).length > 0){
      this.$api.modal.show('', '得意先の異なる出荷明細を、同じ請求データにまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => (this.checkedDeliveryItems[0].segment.payerSegmentId ?? this.checkedDeliveryItems[0].segment.id) != (item.segment.payerSegmentId ?? item.segment.id)).length > 0){
      this.$api.modal.show('', '部門の異なる出荷明細を、同じ請求データにまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => this.checkedDeliveryItems[0].delivery.currencyCode != item.delivery.currencyCode).length > 0){
      this.$api.modal.show('', '取引通貨の異なる出荷明細を、同じ請求データにまとめることはできません。', true, null);
      return;
    }

    // 実行前バリデーション
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.SalesDeliveryAcceptanceWaiting).length > 0){
      this.$api.modal.show('', '請求処理待ちの明細のみを選択して下さい。', true, null);
      return;
    }

    // プロパティの初期化
    var deliveryDate = this.checkedDeliveryItems.map(obj => obj.delivery.deliveryDate).reduce((max, value) => max = max > value ? max : value);
    var delivery = this.checkedDeliveryItems[0].delivery as Common.Delivery; 
    this.bsInvoiceType = delivery.counterpart.invoiceType;
    this.bsPaymentDateType = delivery.counterpart.paymentDateType;
    this.bsExchangeRate = 1;
    this.bsCurrencyCode = delivery.currencyCode;
    // this.getBankAccount(this.bsCurrencyCode);
    this.getCusotmerBankAccountQuery(delivery.counterpart);
    this.bsWorkflowIdAlone = this.$api.perms.getDefaultWorkflowId('workflow_aloneInvoice');
    this.bsWorkflowIdCarryOver = this.$api.perms.getDefaultWorkflowId('workflow_carryOverInvoice' );
    this.onChangeWorkflow();
    this.bsHasAlone = this.bsInvoiceType != Common.InvoiceTypes.ConsolidateInvoiceCarryOver;
    this.bsHasCarryOver = this.bsInvoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver;
    var query = new Common.GetDeliveryCounterpart();
    query.delivery = delivery;
    this.$api.execute(query,true).then(res => {
      this.bsCounterpart = res;
      if(this.bsInvoiceType == Common.InvoiceTypes.SeparateInvoice){
        this.bsSeparateInvoiceFlag = true;
        this.bsBookDate = new Date().getCalendarDate();
        this.bsEnabledSeparateInvoiceFlag = false;
      }
      else{
        this.bsSeparateInvoiceFlag = false;
        this.bsBookDate = this.bsCounterpart.getClosingDate(deliveryDate, this.$api.tenantSettings);
        this.bsEnabledSeparateInvoiceFlag = true;
      }
      if(this.bsInvoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver) this.bsCarryOverInvoiceFlag = true;
      else this.bsCarryOverInvoiceFlag = false;
      this.onBsBookDateChange();
    // ダイアログの表示
    (this.$refs.bookSalesDialog as Components.ListDialog).showDialog();
    });
  }
  }

  // 個別請求フラグが変更された際に、売上日を設定
  public onBsSeparateInvoiceFlagChange(){
    if(this.bsSeparateInvoiceFlag){
      this.bsBookDate = new Date().getCalendarDate();
      this.bsBookDateChangeFlag = false;
    }else{
      var delivery = this.checkedDeliveryItems[0].delivery as Common.Delivery; 
      this.bsBookDate = this.bsCounterpart.getClosingDate(delivery.deliveryDate, this.$api.tenantSettings);
      this.bsBookDateChangeFlag = false;
    }
    this.onBsBookDateChange();
    this.onChangeWorkflow();
  }

  // 売上日変更フラグが変更された際に、売上日を設定
  public onBsBookDateChangeFlagChange(){
    if(!this.bsSeparateInvoiceFlag){
      var delivery = this.checkedDeliveryItems[0].delivery as Common.Delivery; 
      this.bsBookDate = this.bsCounterpart.getClosingDate(delivery.deliveryDate, this.$api.tenantSettings);
      this.onBsBookDateChange();
    }
  }

  // 売上日が変更された際に、支払日を設定
  public onBsBookDateChange(){
    if(this.bsInvoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver && this.bsSeparateInvoiceFlag == false){
      this.bsDueDate = new Date(this.bsBookDate.getTime());
      this.bsDueDate.setDate(this.bsDueDate.getDate() + 1);
      this.bsDueDate = this.bsCounterpart.getClosingDate(this.bsDueDate, this.$api.tenantSettings);//繰越請求は翌締日
    }else{
      this.bsDueDate = this.bsCounterpart.getPaymentDate(this.bsBookDate, this.$api.tenantSettings);
    }

    //売上日が変更された場合に為替レートを取得する
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.bsCurrencyCode;
    query.startDate = this.bsBookDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.bsExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });    
  }
  // public async getBankAccount(currencyCode:string){
  //   const query = new Common.GetBankAccount();
  //   query.currencyCode = currencyCode;
  //   this.$api.execute(query).then(res => {
  //     this.bsBankAccount = res as Common.BankAccount;
  //   });
  // }
  public async getCusotmerBankAccountQuery(customer:Common.Counterpart){
    var customerList = new Array<Common.Counterpart>();
    customerList.push(customer);
    const query = new Common.GetCusotmerBankAccountQuery();
    query.customerList = customerList;
    await this.$api.execute(query).then(res => {
      if(res != null) this.bsBankAccount = res as Common.BankAccount;//初期値を設定するようになったのでブランクで上書きをしないように変更
    });
  }

  // 請求処理の実行
  public async submitBookSales(items:any[], index:number) {
    (this.$refs.bookSalesDialog as Components.ListDialog).closeDialog();
    if(this.execDelivery == true){
      if(this.isSeparate == true)
        return this.deliveryBookSalesSeparate(items, index);
      else
        return this.deliveryBookSales(items, index);
    }else{
      return this.deliveryItemBookSales(items, index);
    }
  }

  public async callBookSalesQuery(index:number){
    // クエリの設定
    var query = new Common.BookSalesQuery();
    query.deliveryItems = this.checkedDeliveryItems;
    query.separateInvoiceFlag = this.bsSeparateInvoiceFlag;
    query.bookDate = this.bsBookDate;
    query.dueDate = this.bsDueDate;
    query.bulkFlag = false;
    query.workflowIdAlone = this.bsWorkflowIdAlone;
    query.workflowIdCarryOver = this.bsWorkflowIdCarryOver;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    if(this.bsCarryOverInvoiceFlag) query.exchangeRate = 1;
    else query.exchangeRate = this.bsExchangeRate;
    query.bankAccount = this.bsBankAccount;
    return this.$api.execute(query,true);
  }

  // 出荷伝票単位の請求処理の実行
  public async deliveryBookSales(items:any[], index:number) {
    this.$api.startWaitCusor();
    // 伝票の明細取得処理と同じクエリで出荷明細を取得する
    const grdVoucherItem:Components.GrdVoucherItem= new Components.GrdVoucherItem();
    grdVoucherItem.voucherType=Common.voucherTypes.SalesDelivery;
    grdVoucherItem.voucherItemType=Common.voucherTypes.SalesDeliveryItem;
    var inputBankAccount = this.bsBankAccount;  // 画面で入力された口座を保持
    // 選択されている伝票分繰り返す
    await this.parentMainList.selectedItems.reduce(async (previous, obj, listIndex) => {
      await previous;
      // 選択されていて、処理対象のDeliveryを確認
      var target = this.deliveries.filter(target => target.deliveryNo == obj.deliveryNo)[0];
      if(target){
          var itemIndex = this.parentMainList.items.indexOf(obj);
          grdVoucherItem.voucherNo = obj.deliveryNo;
          // 請求処理対象のDeliveryItemを取得
          await this.$api.execute(grdVoucherItem.getQuery()).then(res =>{
            // Queryが参照する伝票ごとの初期値を設定
            this.checkedDeliveryItems = (res as Common.LoadResult).result;
            this.checkedDeliveryItems.forEach(item => {
              item.delivery = obj;
              item.segment = obj.segment;
            });
            this.bsCounterpart = target.counterpart.payer ?? target.counterpart;
            // 支払日を都度設定
            this.onBsBookDateChange();
          }).then(async res =>{
            
            // 請求先の請求口座を設定
            await this.getCusotmerBankAccountQuery(this.bsCounterpart);
            if(this.bsBankAccount == null)this.bsBankAccount = inputBankAccount;

            // 出荷処理・画面の更新を実施
            await this.callBookSalesQuery(index).then(r =>{this.$api.find('Delivery', [obj.deliveryNo])
              .then(res2 => this.parent.onWorkflow(itemIndex,res2));});
          });
        }
      }, undefined).finally(()=>{ 
        this.$api.closeWaitCursor(); 
        if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();
      });
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
  }
  
  // 出荷伝票を纏める個別請求処理の実行
  public async deliveryBookSalesSeparate(items:any[], index:number) {
    this.checkedDeliveryItems = new Array();
    
    this.$api.startWaitCusor();
    // 伝票の明細取得処理と同じクエリで出荷明細を取得する
    const grdVoucherItem:Components.GrdVoucherItem= new Components.GrdVoucherItem();
    grdVoucherItem.voucherType=Common.voucherTypes.SalesDelivery;
    grdVoucherItem.voucherItemType=Common.voucherTypes.SalesDeliveryItem;
    var inputBankAccount = this.bsBankAccount;  // 画面で入力された口座を保持

    // 選択されている伝票分繰り返す
    await this.parentMainList.selectedItems.reduce(async (previous, obj, listIndex) => {
      await previous;
      // 選択されていて、処理対象のDeliveryを確認
      var target = this.deliveries.filter(target => target.deliveryNo == obj.deliveryNo)[0];

      if(target){
          var itemIndex = this.parentMainList.items.indexOf(obj);
          grdVoucherItem.voucherNo = obj.deliveryNo;
          // 請求処理対象のDeliveryItemを取得
          await this.$api.execute(grdVoucherItem.getQuery()).then(res =>{
            // Queryが参照する伝票ごとの初期値を設定
            (res as Common.LoadResult).result.forEach(item => {
              item.delivery = obj;
              item.segment = obj.segment;
              this.checkedDeliveryItems.push(item);
            });
          });
        }
      }, undefined).finally(()=>{ });
      
      this.bsCounterpart = this.checkedDeliveryItems[0].delivery.counterpart.payer ?? this.checkedDeliveryItems[0].delivery.counterpart;
      // 請求先の請求口座を設定
      await this.getCusotmerBankAccountQuery(this.bsCounterpart);
      if(this.bsBankAccount == null)this.bsBankAccount = inputBankAccount;

      this.$api.closeWaitCursor(); 
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();

      // 出荷処理・画面の更新を実施
      await this.callBookSalesQuery(index).then(r =>this.parentMainList.reload());

      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
  }

  // 出荷明細単位の請求処理の実行
  public async deliveryItemBookSales(items:any[], index:number) {
    // 請求処理の実行
    return this.callBookSalesQuery(index).then(res=>{ 
      // 画面を更新
      if(this.isItemFlag){
        this.parentMainList.reload().then(()=>{if(this.salesDeliveryItems) this.salesDeliveryItems.onVoucherNoChanged();});
      }else{
        this.$api.find('Delivery', [((this.parentMainList as Components.ListView).selected as Common.SalesDelivery).deliveryNo]).then(res2 => 
          this.parent.onWorkflow(this.parentMainList.currentId,res2));
      }
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();     
      
      var invoices = res as Common.Invoice[];
      var links = invoices.map(invoice=> new Common.ModalLink(invoice.invoiceNo,this.getInvoiceLink(invoice)));
      if(invoices.length == 1){
        this.$api.modal.show('処理結果','以下の請求書が作成・更新されました。',false,()=>{
          var url = this.getInvoiceLink(invoices[0]);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果','以下の請求書が作成・更新されました。',true,null,links,'閉じる');
      }

      return true;

      }).catch(()=>false);     
  }

  // 請求のリンク先を設定
  private getInvoiceLink(invoice:Common.Invoice)
  {
    if(invoice.invoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver)
      return String.format('/sales/CarryoverInvoice?invoiceNo={0}',invoice.invoiceNo);
    else
      return String.format('/sales/AloneInvoice?invoiceNo={0}',invoice.invoiceNo);
  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("請求保存");
    // 締め請求で請求処理時にワークフローを勧めるのは少数と思われるので、個別請求の場合のみワークフローのボタンを表示
    if(this.bsSeparateInvoiceFlag){
      if(this.bsHasAlone && this.bsWorkflowIdAlone!=0)
      {
        var actions = this.$api.perms.getWorkflowActionsHasPermission('aloneInvoice', this.bsWorkflowIdAlone, Common.InvoiceStatus.AloneClosingWaiting);
        actions.forEach(action => {
          this.buttonNames.push(action.actionName);
          this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
        });
      }
      else if(this.bsHasCarryOver && this.bsWorkflowIdCarryOver!=0)
      {
        var actions = this.$api.perms.getWorkflowActionsHasPermission('carryOverInvoice', this.bsWorkflowIdCarryOver, Common.InvoiceStatus.CarryOverWaiting);
        actions.forEach(action => {
          this.buttonNames.push(action.actionName);
          this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
        });
      }
    }
  }
}

